import React from "react";
import { useNavigate } from "react-router-dom";

import darazLogo from "../assets/daraz.png";
import ajkerDealLogo from "../assets/ajkerdeal.png";
import bikroyLogo from "../assets/bikroy.png";
import othobaLogo from "../assets/othoba.png";

import banner1 from "../assets/banner1.png";
import banner2 from "../assets/banner2.png";
import banner3 from "../assets/banner3.png";
import banner4 from "../assets/banner4.png";
import banner5 from "../assets/banner5.png";
import banner6 from "../assets/banner6.png";
import banner7 from "../assets/banner7.png";

import bkashIcon from "../assets/icons/bkash.png";
import nagadIcon from "../assets/icons/nagad.png";
import rocketIcon from "../assets/icons/rocket.png";

import { useAuth } from "../context/AuthContext";
document.body.style.overflowX = "hidden";
// ---------------- DATA ----------------
const menuItems = [
  { icon: "https://cdn-icons-png.flaticon.com/512/1041/1041875.png", text: "ডিপোজিট" },
  { icon: "https://cdn-icons-png.flaticon.com/512/3135/3135706.png", text: "উত্তোলন" },
  { icon: "https://cdn-icons-png.flaticon.com/512/3503/3503786.png", text: "প্যাকেজ" },
  { icon: "https://cdn-icons-png.flaticon.com/512/942/942748.png", text: "আমার কাজ" },
  { icon: "https://cdn-icons-png.flaticon.com/512/747/747376.png", text: "প্রোফাইল" },
  { icon: "https://cdn-icons-png.flaticon.com/512/929/929610.png", text: "রেফার" },
  { icon: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png", text: "লেনদেন" },
  { icon: "https://cdn-icons-png.flaticon.com/512/724/724664.png", text: "সহায়তা" },
];

const contacts = [
  {
    name: "TikTok",
    img: "https://cdn-icons-png.flaticon.com/512/3046/3046121.png",
  },
  {
    name: "Whatsapp",
    img: "https://cdn-icons-png.flaticon.com/512/733/733585.png",
    link: "https://chat.whatsapp.com/E8I8z7MJkZt3E4sMI7yW8N",
  },
  {
    name: "YouTube",
    img: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
  },
  {
    name: "Telegram",
    img: "https://cdn-icons-png.flaticon.com/512/2111/2111646.png",
    link: "https://t.me/earn_money_free01",
  },
];

const partners = [
  { name: "Daraz", img: darazLogo, link: "https://www.daraz.com.bd" },
  { name: "AjkerDeal", img: ajkerDealLogo, link: "https://ajkerdeal.com/en/"},
  { name: "Bikroy", img: bikroyLogo, link: "https://bikroy.com"},
  { name: "Othoba", img: othobaLogo, link: "https://www.othoba.com" },
];
const topBanners = [banner1, banner2, banner3, banner4, banner5, banner6];

const bottomBanners = [banner7];

// ---------------- DASHBOARD COMPONENT ----------------
const Dashboard = () => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
const navigate = useNavigate();
const [balanceLoading, setBalanceLoading] = React.useState(false);

const { logOut } = useAuth();   // <-- এইটা এখানে বসাবে

const [user, setUser] = React.useState(null);
const [loadingUser, setLoadingUser] = React.useState(true);
const [announcement, setAnnouncement] = React.useState(""); // <-- এখানে বসাও

const [showPopup, setShowPopup] = React.useState(true);

React.useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) {
    navigate("/login");
    return;
  }

  const fetchUser = async () => {
    try {
      const res = await fetch("https://api.earnmoney0.top/api/user/me", {
  headers: {
    Authorization: "Bearer " + token,
  },
});

// 🔥 TOKEN EXPIRED CHECK
if (res.status === 401) {
  localStorage.removeItem("token");
  navigate("/login");
  return;
}

const data = await res.json();

      if (data.accountStatus === "Suspended") {
        navigate("/suspended"); // Suspended ইউজার redirect
        return; // কোনো UI load হবে না
      }

      setUser(data);
      setLoadingUser(false);
    } catch (err) {
      console.error(err);
      localStorage.removeItem("token");
      navigate("/login");
    }
  };

  fetchUser();

  // Fetch announcement
  const fetchAnnouncement = async () => {
    try {
      const res = await fetch("https://api.earnmoney0.top/api/user/announcement", {
        headers: { Authorization: "Bearer " + token },
      });
      const data = await res.json();
      if (data.success) setAnnouncement(data.announcement);
    } catch (err) {
      console.error("Announcement fetch error:", err);
    }
  };

  fetchAnnouncement();
}, [navigate]);

  // 🌙 Dark Mode
  const [darkMode, setDarkMode] = React.useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    return savedMode ? JSON.parse(savedMode) : true;
  });

  // 🖼 Banner index
  const [topIndex, setTopIndex] = React.useState(0);
  const [bottomIndex, setBottomIndex] = React.useState(0);

  // ⏱ Auto slider
  React.useEffect(() => {
    const interval = setInterval(() => {
      setTopIndex((prev) => (prev + 1) % topBanners.length);
      setBottomIndex((prev) => (prev + 1) % bottomBanners.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      localStorage.setItem("darkMode", JSON.stringify(!prev));
      return !prev;
    });
  };

  const handleLogout = async () => {
  try {
    await logOut();
    navigate("/login");
  } catch (err) {
    console.error("Logout error:", err);
  }
};
  const handleBalanceClick = () => {
  if (balanceLoading) return;

  setBalanceLoading(true);

  setTimeout(() => {
    setBalanceLoading(false);
  }, 3000);
};

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest("#dropdown-container")) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div style={{ ...styles.page, background: darkMode ? "#0f172a" : "#f8fafc", color: darkMode ? "#fff" : "#0f172a" }}>
      {/* HEADER */}
      <div style={styles.header}>
        <div style={styles.userInfo}>
          <img
  src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
  alt="profile"
  style={{ ...styles.avatar, cursor: "pointer" }}
  onClick={() => navigate("/profile")}
/>
          <div>
  <h3 style={styles.username}>
    {loadingUser ? "Loading.." : user?.name}
  </h3>

  <div style={styles.balanceRow}>
    <span style={styles.currency}>৳</span>

    {balanceLoading && (
  <span style={styles.balanceLoadingText}>
    {(user?.mainBalance || 0)}
  </span>
)}

    <div
      style={{
        transform: balanceLoading ? "translateX(23px)" : "translateX(0)",
        transition: "transform 0.4s ease",
      }}
    >
      <span
        onClick={handleBalanceClick}
        style={{ ...styles.balanceText, cursor: "pointer" }}
      >
        ব্যালেন্স দেখুন
      </span>
    </div>
  </div>
          </div>
        </div>

        {/* LOGOUT ICON + DROPDOWN */}
        <div id="dropdown-container" style={{ position: "relative" }}>
          <div
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style={{
              width: 45,
              height: 45,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/1828/1828490.png"
              alt="logout"
              style={{ width: 22, height: 22 }}
            />
          </div>

          {dropdownOpen && (
            <div style={styles.dropdown}>
              <button style={styles.dropdownBtn} onClick={handleLogout}>
                Log out
              </button>
              <div style={styles.darkModeToggle}>
                <span>Dark Mode</span>
                <label style={styles.switch}>
                  <input
                    type="checkbox"
                    checked={darkMode}
                    onChange={toggleDarkMode}
                  />
                  <span style={styles.slider}></span>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* TOP BANNER SLIDER - Smooth Fade + Slide + Scale */}
<div style={styles.banner}>
  {topBanners.map((banner, i) => (
    <img
      key={i}
      src={banner}
      alt={`top banner ${i}`}
      style={{
        ...styles.bannerImage,
        position: i === topIndex ? "relative" : "absolute",
        opacity: i === topIndex ? 1 : 0,
        transform: i === topIndex ? "scale(1)" : "scale(0.95)",
        transition: "opacity 0.8s ease, transform 0.8s ease",
      }}
    />
  ))}
</div>
   {/* Step 3 Popup */}
{showPopup && (
  <div
    style={{
      ...styles.popupOverlay,
      ...(showPopup ? styles.popupOverlayActive : {}),
    }}
    onClick={() => setShowPopup(false)}
  >
    <div
      style={{
        ...styles.popupBox,
        ...(showPopup ? styles.popupBoxActive : {}),
      }}
      onClick={(e) => e.stopPropagation()} // overlay click এ hide, box click এ prevent
    >
      <h3 style={styles.popupTitle}>বিশেষ অফার!🎉🎉</h3>
      <p style={styles.popupText}>
        আজকে ১,০০০ টাকা ডিপোজিট করুন এবং <span style={styles.highlight}>১,০০০ টাকা বোনাস</span> পান!
      </p>
      <p style={styles.popupSub}>বোনাস সাথে সাথে উত্তোলন করা যাবে।</p>

      <div style={styles.paymentIcons}>
        <img src={bkashIcon} alt="bKash" style={styles.payIcon} />
        <img src={nagadIcon} alt="Nagad" style={styles.payIcon} />
        <img src={rocketIcon} alt="Rocket" style={styles.payIcon} />
      </div>

      <button
        style={styles.popupBtn}
        onClick={() => setShowPopup(false)}
      >
        বুঝেছি
      </button>
    </div>
  </div>
)}

      {/* MENU */}
      {/* Announcement Marquee */}
{announcement && (
  <div style={{
    width: "100%",
    overflow: "hidden",
    background: "#22c55e",
    borderRadius: 12,
    padding: "6px 0",
    marginBottom: 10,
  }}>
    <div style={{
      display: "inline-block",
      whiteSpace: "nowrap",
      paddingLeft: "100%",
      animation: "scrollText 35s linear infinite",
      fontWeight: 600,
      color: "#0f172a",
      fontSize: 14,
    }}>
      📢 {announcement}
    </div>
  </div>
)}

{/* CSS keyframes - component এর return এর ভিতরে */}
<style>
{`
  @keyframes scrollText {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
  }
`}
</style>
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>EARN BD 24/7</h3>
        <div style={styles.menuGrid}>
          {menuItems.map((item, i) => (
  <div
  key={i}
  style={styles.menuItem}
  onClick={() => {
    if (item.text === "ডিপোজিট") {
      navigate("/deposit");
    } else if (item.text === "উত্তোলন") {
      navigate("/withdraw");
    } else if (item.text === "প্যাকেজ") {
      navigate("/packages");
    } else if (item.text === "আমার কাজ") {
      navigate("/mytask");
    } else if (item.text === "প্রোফাইল") {
      navigate("/profile");
    } else if (item.text === "রেফার") {
      navigate("/referral");
    } else if (item.text === "লেনদেন") {
      navigate("/transactions");
    } else if (item.text === "সহায়তা") {
      const el = document.getElementById("contact-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }}
>
    <div style={styles.icon}>
      <img src={item.icon} alt={item.text} style={{ width: 28, height: 28 }} />
    </div>
    <p style={styles.menuText}>{item.text}</p>
  </div>
))}
        </div>
      </div>

      {/* GAME */}
      {/* BOTTOM BANNER SLIDER */}
<div style={styles.banner}>
  <img
    src={banner7}
    alt="bottom banner"
    style={styles.bannerImage}
  />
</div>

      <div style={styles.card} id="contact-section">
  <h3 style={styles.cardTitle}>যোগাযোগ করুন📲</h3>
  <div style={styles.contactGrid}>
  {contacts.map((c, i) => (
    <div
      key={i}
      style={styles.contactItem}
      onClick={() => {
        if (c.link) {
          window.open(c.link, "_blank");
        }
      }}
    >
      <img src={c.img} alt={c.name} style={styles.contactIcon} />
      <p>{c.name}</p>
    </div>
  ))}
</div>
</div>

      {/* PARTNER */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>আমাদে পার্টনার 🤝</h3>
        <div style={styles.partnerGrid}>
  {partners.map((p, i) => (
    <div key={i} style={styles.partnerItem}>
      <a href={p.link} target="_blank" rel="noopener noreferrer">
        <img src={p.img} alt={p.name} style={styles.partnerIcon} />
      </a>
      <p>{p.name}</p>
    </div>
  ))}
</div>
      </div>
    </div>
  );
};

/* STYLES *

export default Dashboard;

/* STYLES */
const styles = {
  page: {
  background: "#0f172a",
  minHeight: "100vh",
  paddingBottom: 30,
  fontFamily: "sans-serif",
  color: "#fff",
  transition: "all 0.3s",
  overflowX: "hidden",   // ✅ ডানে–বামে যাওয়া বন্ধ
},

bannerImage: {
  width: "100%",
  aspectRatio: "16 / 6",
  objectFit: "cover",
  borderRadius: "12px",
},

  partnerIcon: {
    width: 60,
    height: 30,
    objectFit: "contain",
    background: "#fff",
    padding: 5,
    borderRadius: 6,
  },

  header: {
    background: "#1e3a8a",
    color: "#fff",
    padding: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  avatar: {
    width: 50,
    height: 50,
    borderRadius: "50%",
  },

  username: {
    margin: 0,
    fontSize: 18,
    color: "#fff",
  },

  balanceRow: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginTop: 4,
  whiteSpace: "nowrap",
},

currency: {
  fontSize: 14,
  fontWeight: 700,
  color: "#22c55e",
},

balanceText: {
  fontSize: 12,
  background: "#e5fbe8",
  padding: "3px 10px",
  borderRadius: 14,
  color: "#065f46",
  fontWeight: 600,
},

balanceLoadingText: {
  fontSize: 12,
  fontWeight: 600,
  color: "#22c55e",
},

balanceRow: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginTop: 4,
},


  logout: {
    fontSize: 24,
    cursor: "pointer",
    color: "red", // Exit icon লাল
    display: "flex",
    alignItems: "center",
    gap: 5,
  },

  banner: {
  width: "100%",
  padding: "10px",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  overflow: "hidden",   // ✅ extra safety
},
  bannerImg: {
    width: "100%",
    borderRadius: 12,
    objectFit: "cover",
  },

  card: {
    background: "#0b1c2d",  // Dark card
    margin: "10px",
    padding: "15px",
    borderRadius: 12,
    color: "#fff",
  },

  cardTitle: {
    marginBottom: 15,
    color: "#facc15", // bright accent
    fontWeight: 600,
  },

  menuGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 15,
  },

  menuItem: {
    textAlign: "center",
  },

  icon: {
    width: 55,
    height: 55,
    background: "#8b5cf6",
    color: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    fontSize: 22,
  },

  menuText: {
    marginTop: 6,
    fontSize: 13,
    color: "#fff",
  },

  game: {
    padding: 10,
    width: "100%",
  },

  gameImg: {
    width: "100%",
    height: "190px",
    objectFit: "cover",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)", // subtle shadow
  },

  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 15,
    textAlign: "center",
  },

  contactItem: {
    fontSize: 13,
    color: "#fff",
  },

  contactIcon: {
    width: 45,
    height: 45,
    borderRadius: "50%",
    objectFit: "cover",
  },

  marqueeWrapper: {
  width: "100%",
  overflow: "hidden",
  background: "#facc15", // হালকা সোনালি রঙ
  borderRadius: 8,
  padding: "4px 0",
  marginBottom: 8, // card এর উপরে gap
},

marqueeText: {
  display: "inline-block",
  whiteSpace: "nowrap",
  paddingLeft: "100%", // start off screen
  animation: "marquee 10s linear infinite",
  fontSize: 13,
  fontWeight: 600,
  color: "#0f172a",
},

  partnerGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 15,
    textAlign: "center",
  },

  partnerItem: {
    fontSize: 13,
    color: "#fff",
  },

  partnerIcon: {
    width: 50,
    height: "auto",
    objectFit: "contain",
  },

  /* DROPDOWN + DARK MODE */
  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#1e3a8a",
    padding: 10,
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  dropdownBtn: {
    background: "red", // Log out লাল
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
  },

  darkModeToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    paddingTop: 5,
  },

 /* Step 3 POPUP STYLES */
popupOverlay: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)", // subtle dark overlay
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10000,
  opacity: 0,
  pointerEvents: "none",
  transition: "opacity 0.3s ease",
},

popupOverlayActive: {
  opacity: 1,
  pointerEvents: "auto",
},

popupBox: {
  background: "#1e3a8a", // নতুন কালার, সাদা নয়
  padding: 25,
  borderRadius: 16,
  width: "90%",
  maxWidth: 400,
  textAlign: "center",
  color: "#facc15",
  transform: "translateY(-50px) scale(0.95)",
  transition: "all 0.4s cubic-bezier(0.25, 1, 0.5, 1)",
},

popupBoxActive: {
  transform: "translateY(0) scale(1)",
},

popupTitle: { 
  fontSize: 18, 
  fontWeight: 700, 
  marginBottom: 12,
},

popupText: { 
  fontSize: 14, 
  marginBottom: 10 
},

popupSub: { 
  fontSize: 13, 
  marginBottom: 15 
},

highlight: { 
  color: "#22c55e", 
  fontWeight: 700 
},

paymentIcons: { 
  display: "flex", 
  justifyContent: "center", 
  gap: 15, 
  marginBottom: 15 
},

payIcon: { 
  width: 50, 
  height: 50 
},

popupBtn: {
  padding: "8px 20px",
  border: "none",
  borderRadius: 8,
  background: "#22c55e",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
  transition: "background 0.3s ease",
},

popupBtnHover: {
  background: "#16a34a"
},

  switch: {
    position: "relative",
    display: "inline-block",
    width: 40,
    height: 20,
  },

  switchInput: {
    opacity: 0,
    width: 0,
    height: 0,
  },

  slider: {
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#ccc",
    borderRadius: 20,
    transition: ".4s",
  },

  sliderBefore: {
    position: "absolute",
    content: '""',
    height: 16,
    width: 16,
    left: 2,
    bottom: 2,
    backgroundColor: "white",
    borderRadius: "50%",
    transition: ".4s",
  },
};


export default Dashboard;